import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({
  inputTestId,
  toggleTestId,
  showLabel,
  hideLabel,
  icon: Icon,
  className = "",
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      {Icon && <Icon className="w-4 h-4 text-[#5f6b62] absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none" />}
      <input
        {...props}
        type={visible ? "text" : "password"}
        data-testid={inputTestId}
        className={`${className} ${Icon ? "pl-10" : ""} pr-11`}
      />
      <button
        type="button"
        onClick={() => setVisible((value) => !value)}
        data-testid={toggleTestId}
        aria-label={visible ? hideLabel : showLabel}
        title={visible ? hideLabel : showLabel}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-lg text-[#5f6b62] hover:text-[#1e3326] hover:bg-[#f4f0e8] transition-[color,background-color]"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};